import { signOut } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import firebaseConfig from '../../config';

const { databaseId } = firebaseConfig;

function UserProfileFactory(firebase) {
  const checkIfUserCanLogInDirectly = async ({ email }) => {
    const checkIfUserCanLogInDirectlyCallable = httpsCallable(
      firebase.functions,
      'user-account-checkIfUserCanLogInDirectly'
    );
    return checkIfUserCanLogInDirectlyCallable({ email, databaseId });
  };

  const uploadAvatar = async (avatarFile) => {
    const uploadAvatarCallable = httpsCallable(
      firebase.functions,
      'user-avatar-upload'
    );
    return uploadAvatarCallable({ avatarFile, databaseId });
  };

  const logout = async () => signOut(firebase.auth);

  return {
    checkIfUserCanLogInDirectly,
    uploadAvatar,
    logout
  };
}

export default UserProfileFactory;
